import React, { useEffect, useState } from 'react'
import { BoxProps } from '../Box'
import { Text } from '../Text'

export interface CountdownProps extends BoxProps {
  time: Date
  onExpired?: () => void
}

export const Countdown = ({ time, onExpired, ...restProps }: CountdownProps) => {
  const [date, setDate] = useState(new Date())
  const [isExpired, setIsExpired] = useState(false)

  useEffect(() => {
    const timer = setInterval(() => {
      setDate(new Date())
    }, 1000)

    return () => {
      clearInterval(timer)
    }
  }, [])

  const remaining = time.getTime() - date.getTime()

  useEffect(() => {
    if (isExpired) {
      onExpired && onExpired()
    }
  }, [isExpired])

  useEffect(() => {
    if (remaining <= 0) {
      setIsExpired(true)
    } else {
      setIsExpired(false)
    }
  }, [remaining])

  const hours = Math.floor((remaining / (60000 * 60)) % 60)
  const minutes = Math.floor((remaining / 60000) % 60)
  const seconds = Math.floor((remaining / 1000) % 60)

  useEffect(() => {
    const timer = setInterval(() => {
      setDate(new Date())
    }, 1000)

    return () => {
      clearInterval(timer)
    }
  }, [])

  if (remaining <= 0) {
    return (
      <Text color="pink.500" fontFamily="heading" fontSize="3xl">
        EXPIRED
      </Text>
    )
  }

  return (
    <Text color="pink.500" fontFamily="heading" fontSize="3xl">
      {hours < 10 && '0'}
      {hours}:{minutes < 10 && '0'}
      {minutes}:{seconds < 10 && '0'}
      {seconds}
    </Text>
  )
}

export default Countdown
